import { ScrollToTop } from "$components/navigation/ScrollToTop";
import { lazyLoad } from "$routes/_lib/lazy-load";
import { LocalitiesProvider } from "$routes/_lib/localities-context";
import { Route, Routes } from "react-router-dom";

const NewLayout = lazyLoad(() =>
  import(/* webpackChunkName: "NewPatient" */ "./chunk").then((module) => ({
    default: module.default.NewLayout,
  })),
);

const NewPatientPage = lazyLoad(() =>
  import(/* webpackChunkName: "NewPatient" */ "./chunk").then((module) => ({
    default: module.default.NewPatientPage,
  })),
);

const NewPatientPageStep1 = lazyLoad(() =>
  import(/* webpackChunkName: "NewPatient" */ "./chunk").then((module) => ({
    default: module.default.NewPatientPageStep1,
  })),
);

const NewPatientPageStep2 = lazyLoad(() =>
  import(/* webpackChunkName: "NewPatient" */ "./chunk").then((module) => ({
    default: module.default.NewPatientPageStep2,
  })),
);

const NewPatientPageStep3 = lazyLoad(() =>
  import(/* webpackChunkName: "NewPatient" */ "./chunk").then((module) => ({
    default: module.default.NewPatientPageStep3,
  })),
);

const NewPatientDuplicatesPage = lazyLoad(() =>
  import(/* webpackChunkName: "NewPatient" */ "./chunk").then((module) => ({
    default: module.default.NewPatientDuplicatesPage,
  })),
);

const NewPatientCompletePage = lazyLoad(() =>
  import(/* webpackChunkName: "NewPatient" */ "./chunk").then((module) => ({
    default: module.default.NewPatientCompletePage,
  })),
);

const NewPatientRegistrationPaymentPage = lazyLoad(() =>
  import(/* webpackChunkName: "NewPatient" */ "./chunk").then((module) => ({
    default: module.default.NewPatientRegistrationPaymentPage,
  })),
);

const NewCardsActivateCardPage = lazyLoad(() =>
  import(/* webpackChunkName: "NewPatient" */ "./chunk").then((module) => ({
    default: module.default.NewCardsActivateCardPage,
  })),
);

const NewCardsRegistrationConfirmedPage = lazyLoad(() =>
  import(/* webpackChunkName: "NewPatient" */ "./chunk").then((module) => ({
    default: module.default.NewCardsRegistrationConfirmedPage,
  })),
);

const NewCardsSendPinPage = lazyLoad(() =>
  import(/* webpackChunkName: "NewPatient" */ "./chunk").then((module) => ({
    default: module.default.NewCardsSendPinPage,
  })),
);

const NewCardsShowPinPage = lazyLoad(() =>
  import(/* webpackChunkName: "NewPatient" */ "./chunk").then((module) => ({
    default: module.default.NewCardsShowPinPage,
  })),
);

/*
NewPatientPage and NewLayot should not be lazy loaded 
since they are require to be preCached by the serviceWorker,
so they have to linked to the main bundle, not a separate one.
*/

export const NewPatientRoutes = () => {
  return (
    <LocalitiesProvider>
      <Routes>
        <Route element={<NewLayout />}>
          <Route path="patient" element={<ScrollToTop />}>
            <Route index element={<NewPatientPage />} />
            <Route path="step1" element={<NewPatientPageStep1 />} />
            <Route path="duplicates" element={<NewPatientDuplicatesPage />} />
            <Route path="step2-v2" element={<NewPatientPageStep2 />} />
            <Route path="step3" element={<NewPatientPageStep3 />} />
            <Route path="complete" element={<NewPatientCompletePage />} />
            <Route
              path="registration-payment"
              element={<NewPatientRegistrationPaymentPage />}
            />
          </Route>
          <Route path="cards">
            <Route
              path="activate-card"
              element={<NewCardsActivateCardPage />}
            />
            <Route
              path="registration-confirmed"
              element={<NewCardsRegistrationConfirmedPage />}
            />
            <Route path="send-pin" element={<NewCardsSendPinPage />} />
            <Route path="show-pin" element={<NewCardsShowPinPage />} />
          </Route>
        </Route>
      </Routes>
    </LocalitiesProvider>
  );
};
